import { render, staticRenderFns } from "./ModifyPrice.vue?vue&type=template&id=f1b8f2a6&"
import script from "./ModifyPrice.vue?vue&type=script&lang=js&"
export * from "./ModifyPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports